export default __webpack_public_path__ + "assets/kosovo-flag.png";